import React, { useEffect, useState, useContext } from "react";
import { Button, Table, Empty } from "antd";
import { UserAddOutlined, LoadingOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { translate } from "../../locale";
import UserServices from "../../services/UserServices";
import { AdminContext } from "../../providers/AdminContext";
import InviteContact from "../Modals/InviteContact";
import DashServices from "../../services/DashServices";
import { TableHelper } from "../../helpers/TableHelper";
import Link from "antd/lib/typography/Link";
import PropTypes from "prop-types";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const ContactsTable = ({ reload }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [isSuper, setIsSuper] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isCoordinator, setIsCoordinator] = useState(false);
  const [isProfessional, setIsProfessional] = useState(false);
  const [configUser, setConfigUser] = useState(false);
  const [subscriptionsList, setSubscriptionsList] = useState([]);
  const { user } = useContext(AdminContext);
  const roles = {
    "eira-super-admin": translate("Super Admin"),
    "eira-company-admin": translate("Admin"),
    "eira-company-coordinator": translate("Coordinador"),
    "eira-professional": translate("Profesional"),
    "eira-patient": translate("Paciente"),
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [values, setValues] = useState({
    emails: "",
  });
  const { id } = useParams();

  const [tableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
  });

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      sorter: { multiple: 6 },
      render: (v, r, i) => (
        <div>
          <Button
            disabled={
              r.role !== "eira-professional" && r.role !== "eira-patient"
            }
            type="text"
            icon={<UserAddOutlined />}
            size="small"
            className="border-0"
            onClick={() => handleInviteContact(r)}
          />
        </div>
      ),
    },
    {
      title: translate("Nombre"),
      dataIndex: "first_name",
      key: "first_name",
      render: (_, record) => {
        if (
          record.role === "eira-patient" ||
          record.role === "eira-professional" ||
          record.role === "eira-company-coordinator"
        ) {
          return (
            <Link
              onClick={() =>
                navigate(
                  `/admin/buscar-paciente/${record.username}${
                    record.role === "eira-patient" ? "" : "/personal-details"
                  }`,
                )
              }
              className="!text-black hover:!text-custom_primary"
            >
              {record.first_name}
            </Link>
          );
        }
        return record.first_name;
      },
      sorter: (a, b) => {
        if (a.first_name < b.first_name) return -1;
        if (a.first_name > b.first_name) return 1;
        return 0;
      },
    },
    {
      title: translate("Apellido"),
      dataIndex: "last_name",
      key: "last_name",
      defaultSortOrder: "ascend",
      render: (_, record) => {
        if (
          record.role === "eira-patient" ||
          record.role === "eira-professional" ||
          record.role === "eira-company-coordinator"
        ) {
          return (
            <Link
              onClick={() =>
                navigate(
                  `/admin/buscar-paciente/${record.username}${
                    record.role === "eira-patient" ? "" : "/personal-details"
                  }`,
                )
              }
              className="!text-black hover:!text-custom_primary"
            >
              {record.last_name}
            </Link>
          );
        }
        return record.last_name;
      },
      sorter: (a, b) => {
        if (a.last_name < b.last_name) return -1;
        if (a.last_name > b.last_name) return 1;
        return 0;
      },
    },
    {
      title: translate("Email"),
      dataIndex: "email",
      key: "email",
      render: (_, record) => {
        return record.username;
      },
      sorter: (a, b) => {
        if (a.username < b.username) return -1;
        if (a.username > b.username) return 1;
        return 0;
      },
    },
    {
      title: translate("Tipo"),
      dataIndex: "type",
      key: "type",
      sorter: { multiple: 2 },
      render: (_, r) => roles[r.role],
      filters: [
        {
          text: translate("Super Admin"),
          value: "eira-super-admin",
        },
        {
          text: translate("Admin"),
          value: "eira-company-admin",
        },
        {
          text: translate("Coordinador"),
          value: "eira-company-coordinator",
        },
        {
          text: translate("Profesional"),
          value: "eira-professional",
        },
        {
          text: translate("Paciente"),
          value: "eira-patient",
        },
      ],
      onFilter: (value, record) => record.role.indexOf(value) === 0,
    },
    {
      title: "Suscripción",
      dataIndex: "subscriptions",
      key: "subscriptions",
      sorter: { multiple: 1 },
      render: (subscriptions) =>
        subscriptions
          .map((subscriptions) => subscriptions.subscription_name)
          .join(", "),
      filters: subscriptionsList,
      filterMode: "tree",
      filterSearch: true,
      onFilter: (value, record) =>
        record.subscriptions[0]?.subscription_name.indexOf(value) === 0,
    },
  ];

  useEffect(() => {
    if (reload !== null || configUser === true) {
      getSubscriptionList();
      loadData();
    }
  }, [reload, configUser]);

  useEffect(() => {
    if (user !== null && user !== undefined) {
      setIsSuper(user.user.rol === "eira-super-admin");
      setIsAdmin(user.user.rol === "eira-company-admin");
      setIsCoordinator(user.user.rol === "eira-company-coordinator");
      setIsProfessional(user.user.rol === "eira-professional");
    }
    setConfigUser(true);
  }, [user]);

  const getSubscriptionList = async () => {
    try {
      const res = await DashServices.getSubscriptions(id);
      if (res.status >= 200 && res.status < 300) {
        let formatArray = [];
        res.data.subscriptions.map((item) => {
          formatArray.push({
            text: item.name,
            value: item.name,
          });
        });
        setSubscriptionsList(formatArray);
      }
    } catch (error) {
      console.error("getSubscriptionList error: ", error);
    }
  };

  const canViewRoleData = (role) => {
    switch (role) {
      case "super-admins":
        return isSuper;
      case "admins":
        return isSuper || isAdmin;
      case "coordinators":
        return isSuper || isAdmin || isCoordinator;
      case "professionals":
      case "patients":
        return isSuper || isAdmin || isCoordinator || isProfessional;
      default:
        return false;
    }
  };

  const processRoleData = (contacts, roleKey, roleName) => {
    if (contacts.length > 0 && canViewRoleData(roleKey)) {
      return contacts.map((item) => ({
        ...item,
        role: roleName,
      }));
    }
    return [];
  };

  const loadData = async () => {
    setLoading(true);
    try {
      let data = {
        page_size: tableParams.pagination.pageSize,
        page_num: tableParams.pagination.current,
      };
      const sorter = TableHelper.sorter(tableParams);
      if (sorter !== null) {
        data = { ...data, order_by: sorter };
      }
      const res = await UserServices.getContacts(data);
      if (res.status >= 200 && res.status < 300) {
        const contacts = res.data.contacts;

        const superAdminsData = processRoleData(
          contacts["super-admins"],
          "super-admins",
          "eira-super-admin",
        );

        const adminsData = processRoleData(
          contacts.admins,
          "admins",
          "eira-company-admin",
        );

        const coordinatorsData = processRoleData(
          contacts.coordinators,
          "coordinators",
          "eira-company-coordinator",
        );

        const professionalsData = processRoleData(
          contacts.professionals,
          "professionals",
          "eira-professional",
        );

        const patientsData = processRoleData(
          contacts.patients,
          "patients",
          "eira-patient",
        );

        const newData = [
          ...superAdminsData,
          ...adminsData,
          ...coordinatorsData,
          ...professionalsData,
          ...patientsData,
        ];

        setData(newData);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleInviteContact = (user) => {
    setModalVisible(true);
    setValues({ emails: user.username, role: user.role });
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleModalComplete = () => {
    setModalVisible(false);
  };

  return (
    <>
      <Table
        rowKey={(i) => i.id}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        scroll={{ x: 300 }}
      />
      <InviteContact
        data={values}
        visible={modalVisible}
        onCancel={handleModalCancel}
        onComplete={handleModalComplete}
      />
    </>
  );
};

ContactsTable.propTypes = {
  reload: PropTypes.bool,
};

export default ContactsTable;
